import { Box, FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material';
import { forwardRef, useEffect } from 'react';
import {
  ReadOnly,
  useEntityPermission,
  useFormPermissions,
  useLocalization,
} from '@ui-framework/index';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { END_DATE_OPTIONS } from '../../../../utils/constants';
import EndDate from '../EndDate';

const RecurringOptionsEndDate = forwardRef((props, ref) => {
  const { formatMessage } = useLocalization();
  const { control, setValue, clearErrors } = useFormContext();
  const { isReadOnly } = useEntityPermission();
  const { permissions } = useFormPermissions();
  const recurringEndDateOptions = useWatch({
    control,
    name: 'recurringEndDateOptions',
  });

  useEffect(() => {
    if (!recurringEndDateOptions) {
      setValue('recurringEndDateOptions', END_DATE_OPTIONS[0].value);
    }
  }, []);

  useEffect(() => {
    if (recurringEndDateOptions === 'NO_END_DATE') {
      clearErrors('endDate');
    }
  }, [recurringEndDateOptions]);

  if (
    isReadOnly(permissions?.recurringEndDateOptions, recurringEndDateOptions)
  ) {
    return (
      <Box>
        <ReadOnly name="recurringEndDateOptions">
          {
            END_DATE_OPTIONS(formatMessage).find(
              s => s.value === recurringEndDateOptions,
            ).label
          }{' '}
          {recurringEndDateOptions === 'END_BY' && (
            <EndDate permission={permissions.endDate} />
          )}
        </ReadOnly>
      </Box>
    );
  }

  return (
    <Stack spacing={2} ref={ref}>
      <Controller
        control={control}
        name="recurringEndDateOptions"
        render={({ field }) => {
          return (
            <RadioGroup {...field}>
              {END_DATE_OPTIONS(formatMessage).map(item => {
                return (
                  <Stack
                    direction="row"
                    sx={{ alignItems: 'normal' }}
                    key={item.value}>
                    <FormControlLabel
                      key={item.value}
                      value={item.value}
                      control={<Radio size="small" />}
                      label={item.label}
                    />
                    {item.value === 'END_BY' ? (
                      <EndDate
                        disabled={recurringEndDateOptions !== 'END_BY'}
                      />
                    ) : (
                      <input type="hidden" {...field} value="NO_END_DATE" />
                    )}
                  </Stack>
                );
              })}
            </RadioGroup>
          );
        }}
      />
    </Stack>
  );
});

export default RecurringOptionsEndDate;
